import { canPermission } from './../directives/can-permission';
import { clickOutside } from './../directives/click-outside';
import { createApp } from "vue"
import { lang, translate, isEn, isAr } from "./translation";
import { initData } from './init';
import { can } from './permissions';
import { user } from './user';
import { confirm } from '../directives/confirm';
import DynamicFields from "../components/form/dynamic-fields.vue";



export function createPage (component) {
    initData().then(() => {
        const app = createApp(component);
        app.config.globalProperties.translate = translate;
        app.config.globalProperties.lang = lang;
        app.config.globalProperties.isEn = isEn;
        app.config.globalProperties.isAr = isAr;
        app.config.globalProperties.can = can;
        app.config.globalProperties.user = user;
        app.config.globalProperties.isDeveloper = () => user()?.type === 'developer';
        app.config.globalProperties.isMaster = () => user()?.type === 'master';
        app.config.globalProperties.isAdmin = () => user()?.type === 'admin';
        app.config.globalProperties.isEmployee = () => user()?.type === 'employee';
        app.config.globalProperties.isClient = () => user()?.type === 'client';
        app.directive("click-outside", clickOutside);
        app.directive("can", canPermission);
        app.directive("confirm", confirm);
        app.provide('app', app);
        app.component('dynamic-fields', DynamicFields);
        app.mount('#page');
    })
}

export function createApplication (component, category) {
    initData().then(() => {
        const app = createApp(component);
        app.config.globalProperties.translate = translate;
        app.config.globalProperties.lang = lang;
        app.config.globalProperties.isEn = isEn;
        app.config.globalProperties.isAr = isAr;
        app.config.globalProperties.user = user;
        app.config.globalProperties.appCategory = category;
        app.config.globalProperties.isDeveloper = () => user()?.type === 'developer';
        app.config.globalProperties.isMaster = () => user()?.type === 'master';
        app.config.globalProperties.isAdmin = () => user()?.type === 'admin';
        app.directive("click-outside", clickOutside);
        app.provide('app', app);
        app.mount(`#${category}`);
    })
}
